
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import TrackingService from '@/services/TrackingService'

@Mixin
export default class TrackingMixin extends Vue {
	mounted () {
		const router: any = this.$router
		if (typeof router.currentRoute.path === 'string') {
			const seqNumber: string[] | null = router.currentRoute.path.match(/\d{1,2}/g)

			// Distinguish pagemane to send proper virtual path
			if (!!seqNumber && typeof seqNumber[0] === 'string') {
				TrackingService.pushVirtPath(`refundcheckstep${+seqNumber[0] + 1}`)
			} else {
				TrackingService.pushVirtPath(`refundcheckstep-${router.currentRoute.path.slice(1)}`)
			}
		}
	}
}
